import PropTypes from 'prop-types';
import React from 'react';
import { EditableTableCell } from 'components/EditableTable';
import cx from 'classnames';
// import { error as parseError } from '../../../utils';
import inputStyles from 'styles/input.scss';
import S from 'styles/table.scss';

const LevelerInputCell = ({ levelerItems, attr, label, onChange, cellValue,
                     type, className, cellReadOnly }) => {
  const value = levelerItems[attr];
  const error = levelerItems.errors && levelerItems.errors[attr];
  const cellVal = (value === null || cellValue === null) ? '' : cellValue || value;
  const cellProps = { label, onChange, error, value: cellVal, cellReadOnly };
  return (<EditableTableCell {...cellProps}>
    <input
      type={type}
      value={value === null ? '' : value}
      className={cx(inputStyles.inputElement, S.input, className)}
    />
  </EditableTableCell>);
};

LevelerInputCell.defaultProps = {
  cellValue: '',
  display: true,
  type: 'text',
  className: '',
  cellReadOnly: false,
};

LevelerInputCell.propTypes = {
  levelerItems: PropTypes.object.isRequired,
  display: PropTypes.bool,
  attr: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  cellValue: PropTypes.node,
  type: PropTypes.string,
  className: PropTypes.string,
  cellReadOnly: PropTypes.bool,
};

export default LevelerInputCell;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/warehouseMaterials/components/levelerInputCell.jsx